export default "__VITE_ASSET__BV3gZxGZ__"